import { render } from "./AptStatsView.vue?vue&type=template&id=16bdd48c&ts=true"
import script from "./AptStatsView.vue?vue&type=script&lang=ts"
export * from "./AptStatsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__